import React from "react";

const SortableHeader = ({
  label,
  sortKey,
  activeSortKey,
  sortDir,
  onSort,
  style = {},
  align = "left",
}) => {
  const isActive = sortKey === activeSortKey;

  const indicator = isActive
    ? sortDir === "asc"
      ? " ↑"
      : " ↓"
    : " ⇅";

  return (
    <div
      onClick={() => onSort(sortKey)}
      style={{
        ...style,
        textAlign: align,
        cursor: "pointer",
        userSelect: "none",
        whiteSpace: "nowrap",
      }}
    >
      {label}
      <span style={{ opacity: isActive ? 0.85 : 0.4 }}>{indicator}</span>
    </div>
  );
};

export default SortableHeader;